module.exports = __webpack_public_path__ + "assets/img/2.483785d9.png";